/* eslint-disable no-case-declarations */
import React, { useContext, useImperativeHandle } from 'react';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { useTheme } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import {
  Approval,
  Download,
  Cmsapproved,
  Due,
  Sent,
  Downloaded,
  Submit_Due,
} from '../HospiceItemSet/constants';
import {
  CellDiv,
  StyledSpan,
  StyledButton,
  DownloadIcon,
} from '../../components/layout/WrapperDiv';
import { HISContext } from '../Context/HISContext';
import {
  SET_OPEN_ROW,
  ACCPT,
  APR,
  DWN,
  CustomCell,
} from '../Context/constants';
import { formatDueStatement } from '../Context/his-utils';
import defaults from '../../translations/en.json';

export const MultiPatientCellRenderer = React.forwardRef((props: any, ref) => {
  useImperativeHandle(ref, () => ({
    getReactContainerClasses() {
      return ['custom-cell'];
    },
    getReactContainerStyle() {
      return {
        display: 'inline-block',
        width: '100%',
      };
    },
  }));

  const {
    fetchPatientApprovalHIS,
    dispatch,
    revertToDownload,
    acceptPatientHIS,
  } = useContext(HISContext);

  const { palette } = useTheme() as any;

  const { formatMessage } = useIntl();

  const getDate = (text: string) => {
    const split = text.split(' ');
    return text?.includes('/') ? split[split.length - 1] : text;
  };
  const { data, expandRow, node } = props;

  const {
    possibleactions,
    approvaleventdisplay,
    downloadeventdisplay,
    accepteventdisplay,
    statusdisplay,
    expanded,
  } = data;

  const buttonStyle = {
    backgroundColor: palette.primary.main,
    color: palette.text.contrastPrimaryPaper,
  };

  // can be []
  const value = props && props.value;

  const fetchHIS = () => {
    fetchPatientApprovalHIS(data);
    dispatch({ type: SET_OPEN_ROW, payload: data });
  };

  // eslint-disable-next-line consistent-return
  const getCellUI = (
    type?: any,
    text?: string,
    color?: string,
    displayRedownload?: boolean,
  ) => {
    const spanStyle =
      displayRedownload && !expanded
        ? { color, marginLeft: '25px' }
        : { color };
    switch (type) {
      case 'string':
        return (
          <CellDiv className={CustomCell}>
            <StyledSpan
              onClick={() => expandRow(props)}
              style={{ color: color || palette.text.secondary }}
              expanded={expanded}
            >
              {expanded ? text : getDate(text || '')}
            </StyledSpan>
          </CellDiv>
        );
      case ACCPT: // can be APPROVE or CMS ACCEPTANCE => can be a post or a put
        return (
          <CellDiv className={CustomCell}>
            <StyledButton
              variant="contained"
              style={buttonStyle}
              onClick={() => acceptPatientHIS(node)}
            >
              {text}
            </StyledButton>
          </CellDiv>
        );
      case APR: // can be APPROVE or CMS ACCEPTANCE => can be a post or a put
        return (
          <CellDiv className={CustomCell}>
            <StyledButton
              variant="contained"
              style={buttonStyle}
              onClick={fetchHIS}
            >
              {text}
            </StyledButton>
          </CellDiv>
        );
      case Downloaded:
        return (
          <CellDiv
            className={CustomCell}
            style={{ color: palette.text.secondary }}
            onClick={() => expandRow(props)}
          >
            {defaults.readyForDownload}
          </CellDiv>
        );
      case Sent:
        return (
          <CellDiv className={CustomCell}>
            <StyledSpan
              expanded={expanded}
              style={spanStyle}
              onClick={() => expandRow(props)}
            >
              {expanded ? text : getDate(text || '')}
            </StyledSpan>
            {displayRedownload && (
              <DownloadIcon>
                <AutorenewIcon onClick={() => revertToDownload(node)} />
              </DownloadIcon>
            )}
          </CellDiv>
        );
      default:
        return <CellDiv className={CustomCell}></CellDiv>;
    }
  };

  const getUI = () => {
    let type;
    let color;
    let newValue;
    let displayRedownload;
    const mainColor = palette.getContrastText(palette.background.paper);
    switch (props.title) {
      case Approval:
        if (approvaleventdisplay) {
          color = mainColor;
          type = 'string';
          newValue = approvaleventdisplay;
        } else if (possibleactions?.includes(APR)) {
          newValue = defaults.ReviewDoc;
          type = APR;
        } else {
          newValue = statusdisplay;
          type = 'string';
          color = mainColor;
        }
        break;
      case Download:
        if (possibleactions?.includes(DWN)) {
          if (downloadeventdisplay) {
            newValue = downloadeventdisplay;
            displayRedownload = possibleactions?.includes(ACCPT);
            type = Sent;
            color = mainColor;
          } else if (approvaleventdisplay && !downloadeventdisplay) {
            type = Downloaded;
            color = mainColor;
          }
        } else if (downloadeventdisplay) {
          newValue = downloadeventdisplay;
          type = Sent;
          color = mainColor;
        }
        break;
      case Cmsapproved:
        if (accepteventdisplay) {
          newValue = accepteventdisplay;
          type = 'string';
          color = mainColor;
        } else if (possibleactions?.includes(ACCPT)) {
          newValue = defaults.RECORDACC;
          type = ACCPT;
        }
        break;
      case Due:
      case Submit_Due:
        const [dueDateColor, dueDateStatement] = formatDueStatement(
          value,
          formatMessage,
          palette,
        );
        newValue = `${dueDateStatement} ${value}`;
        type = 'string';
        color = dueDateColor;
        break;
      default:
    }

    return getCellUI(type, newValue, color, displayRedownload);
  };
  return getUI();
});
